import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

const sections = [
  {
    id: 'intro',
    title: '1. Introduction',
    content: `This document is an electronic record as defined under the Information Technology Act, 2000 and the applicable rules made thereunder. It has been generated by a computer system and does not require any physical or digital signatures.

This document is published in accordance with Rule 3(1) of the Information Technology (Intermediary Guidelines and Digital Media Ethics Code) Rules, 2021. It contains the terms of use, privacy policy, and rules and regulations governing the access and use of weddyfyp (referred to as the "Website" and "App").

Welcome to Weddyfyp. These Terms and Conditions ("Terms") govern your access to and use of the Weddyfyp mobile application and website ("Platform"), operated by Roald Software Solutions Private Limited (CIN: U74999TG2018PTC128175), having its registered office at A/P P NO 11 & 12, 206, SRI S RESIDENCY, OLD BOWENPALLY, HYDERABAD 500011, Telangana, India ("Company", "we", "us", or "our").

PLEASE READ THESE TERMS AND CONDITIONS CAREFULLY BEFORE USING THE WEBSITE OR APP. By accessing, browsing, or otherwise using the Website or App, you agree to be bound by these Terms and Conditions (the "Agreement"). If you do not agree with any part of the Terms, please do not use the weddyfyp Website or App, or any services offered by Roald Software Solutions Private Limited. These Terms also include and incorporate any applicable policies as amended and updated from time to time.

In this document:
• "weddyfyp Member" refers to any person accessing or using the Website or App and its services, including but not limited to the prospective bride or groom, or a family member such as a father, mother, brother, sister, relative, or friend (collectively referred to as the "Registrant").
• The terms "You" or "User" may be used interchangeably with "weddyfyp Member".
• "weddyfyp Services" refers to the services made available through the Website or App by Roald Software Solutions Private Limited.

By registering, accessing, or using the Platform in any way, you confirm that you have read, understood, and agree to be bound by these Terms in full. If you do not accept these Terms, you must not use the Platform.

These Terms constitute a legally binding agreement between you and the Company. We may update these Terms from time to time. Significant changes will be communicated to you, and continued use of the Platform after any update constitutes your acceptance of the revised Terms.`,
  },
  {
    id: 'nature',
    title: '2. Nature of the Platform',
    content: `Weddyfyp is a matrimonial platform created exclusively to help individuals find a life partner for the purpose of marriage.

This Platform is strictly for matrimonial purposes only. It is not a dating application, a social networking service, a friendship platform, or an adult content service. Any use of Weddyfyp inconsistent with its matrimonial purpose will result in immediate account removal without refund.

The Company acts solely as a facilitator that provides a platform for members to interact. We do not verify or vouch for the authenticity of every piece of information provided by members, and we do not guarantee the success of any match or the accuracy of information shared by other members. Members are solely responsible for exercising due diligence and judgment when interacting with others.`,
  },
  {
    id: 'eligibility',
    title: '3. Eligibility to Register',
    content: `A. Access to weddyfyp is strictly reserved for the following individuals:

• Indian Citizens and Nationals
• Persons of Indian Origin (PIO)
• Non-Resident Indians (NRI)
• Individuals of Indian descent or heritage
• Individuals who are genuinely seeking to marry someone of Indian origin

B. To create an account on Weddyfyp, you must:

• Be at least 18 years of age (for female members) or 21 years of age (for male members), consistent with the legal age of marriage under Indian law, or the minimum legal age for marriage in your jurisdiction — whichever is higher
• Be legally eligible to marry under applicable Indian law or the law of the country you reside in
• If you are undergoing divorce proceedings, you may still use the platform, provided you clearly mention your status as "Awaiting Divorce"
• If you are residing outside India, you confirm that you are legally permitted to marry under the laws of your country of residence and that you will also comply with Indian laws regarding marriage with a person of Indian origin
• Not currently be suspended, banned, or restricted from the Platform for any prior violation
• Have a valid mobile number that you own and control
• Have full legal capacity to enter into binding contracts

C. If you are creating or managing a profile on behalf of someone else (such as a family member or friend), you confirm that you have obtained their full consent to do so and to access or use the weddyfyp platform on their behalf.

By completing registration, you represent and warrant that all eligibility criteria stated above apply to you. If we discover at any point that a member does not meet these requirements, we reserve the right to terminate their account immediately without notice.`,
  },
  {
    id: 'registration',
    title: '4. Registration and Account Creation',
    content: `To use Weddyfyp, you must register by providing accurate and complete information, including your name, date of birth, gender, mobile number, and such other details as the registration form requires.

When registering, please note the following:

• Read each field carefully before entering your details or selecting options.
• Avoid entering information in incorrect fields (e.g., adding social media IDs or repeating the same details in multiple fields).
• Do not upload photos that do not belong to you.
• All information you provide — including recent photographs — must be truthful and up to date.

If weddyfyp requires additional details to improve your matchmaking experience, you agree to provide the requested information. You may also fill in your contact details during our promotional campaigns, allowing our customer support team to reach out and assist you with registration.

To enhance your chances of finding a suitable match, weddyfyp may display your profile on other community-based websites or platforms owned by Roald Software Solutions Private Limited.

Upon registration:
• A one-time password (OTP) will be sent to your mobile number for verification.
• You must complete OTP verification to activate your account.
• Each mobile number may only be associated with one active account.
• Duplicate profiles of the same individual are not allowed. weddyfyp has the right to suspend or terminate any such duplicate accounts without notice.

You are solely responsible for maintaining the confidentiality of your login credentials. Any activity that occurs under your account is your responsibility. If you suspect that your account has been accessed without your authorisation, you must notify us immediately at info@weddyfyp.com.

By registering on weddyfyp, you confirm that your intention is genuine and specifically for the purpose of seeking a lawful marriage.

• Registration is strictly limited to individual users.
• Businesses, organizations, or individuals engaged in similar or competing matchmaking services are prohibited from using the platform or accessing member data for commercial purposes.
• weddyfyp reserves the right to take appropriate legal action in case of any violation of these terms.

If, at any time, it is found (or reported by a third party) that the information provided by you — including photos — is false, inaccurate, or incomplete, weddyfyp reserves the right to suspend or terminate your account immediately and deny further access to the platform.

The Company reserves the right to refuse registration to any applicant at its sole discretion, without being required to provide reasons.`,
  },
  {
    id: 'profile',
    title: '5. Profile Information and Accuracy',
    content: `Your profile is your representation to other members on Weddyfyp. You agree that:

• All information you provide — including your name, age, date of birth, height, weight, education, occupation, income, religion, caste, community, family background, and any other details — must be truthful, accurate, and kept up to date at all times
• You will not misrepresent your marital status, qualifications, profession, financial status, or any other personal information
• You are required to disclose any significant health conditions or physical disabilities in your profile — failure to do so is a violation of these Terms and may lead to account suspension
• You will not create a profile on behalf of another person without their full and express consent
• You will promptly update your profile if any information changes, particularly your marital status

The Company reserves the right to review, edit, or remove any profile information that it determines — at its sole discretion — to be false, misleading, offensive, or in violation of these Terms. Providing false information is a serious violation and will result in immediate account termination.`,
  },
  {
    id: 'photos',
    title: '6. Profile Photographs',
    content: `Your profile photograph is one of the most important elements of your profile. You agree to:

• Upload only genuine, recent photographs of yourself (not older than 3 months)
• Not upload photographs of any other person, including celebrities, stock images, cartoon characters, or any image that does not accurately represent your current appearance
• Ensure that all uploaded photographs are decent, appropriate, and not offensive or obscene
• Not upload photographs that contain watermarks, contact details, URLs, or promotional material
• Not upload group photographs as your primary profile picture

By uploading photographs to Weddyfyp, you confirm that you hold the rights to those photographs and that uploading them does not infringe the rights of any third party.

The Company reserves the right to remove photographs that do not comply with these guidelines without prior notice. Repeated violations of the photograph policy will result in account suspension.`,
  },
  {
    id: 'conduct',
    title: '7. Member Conduct and Responsibilities',
    content: `Every member of Weddyfyp is expected to behave with honesty, respect, and decency. You agree to:

• Treat all other members with dignity and respect at all times
• Engage with the Platform and other members in good faith
• Use the Platform exclusively for its intended matrimonial purpose
• Take full responsibility for all interactions you initiate or participate in on the Platform

You must not:
• Harass, threaten, intimidate, stalk, or use abusive language toward any other member
• Use the Platform to spread rumours, false information, or defamatory content about any person
• Solicit money, financial assistance, loans, gifts, or any other form of financial benefit from other members
• Share another member's personal information, photographs, or communications with third parties without their explicit consent
• Engage in any form of discriminatory behaviour based on religion, caste, gender, race, or any other protected characteristic

Violations of this clause will result in immediate account suspension or permanent removal, at our sole discretion and without prior notice.`,
  },
  {
    id: 'prohibited',
    title: '8. Prohibited Activities',
    content: `In addition to the conduct standards set out above, the following activities are strictly prohibited on Weddyfyp:

• Impersonating any person or entity, or falsely claiming affiliation with any person, organisation, or institution
• Using the Platform to conduct commercial activity, including advertising, soliciting business, or promoting products or services
• Sending unsolicited commercial messages, spam, or bulk communications to other members
• Collecting, harvesting, or compiling data about other members without their express consent
• Sharing confidential or sensitive information such as bank details, financial information, or other sensitive personal data with other members
• Engaging in any form of physical relationship with another member before marriage
• Using automated bots, scripts, or other unauthorised means to access or interact with the Platform
• Attempting to bypass, compromise, or test the security systems of the Platform
• Reverse-engineering, decompiling, or attempting to extract the source code of the Platform or its applications
• Interfering with the proper functioning of the Platform or the experience of other members
• Creating or using the Platform to build a competing product or service
• Uploading or transmitting any malware, viruses, or malicious code
• Using the Platform for any activity that is unlawful under Indian law or the laws of the country in which you reside

The Company reserves the right to take legal action against members found engaging in any of the above prohibited activities.`,
  },
  {
    id: 'communication',
    title: '9. Communication Between Members',
    content: `Weddyfyp provides messaging features to allow members to communicate with one another. When using these features, you agree to:

• Use in-app messaging exclusively for the purpose of matrimonial communication
• Not use the messaging system to send spam, bulk messages, abusive content, or anything inconsistent with the Platform's matrimonial purpose
• Not share personal contact details (phone numbers, email addresses, social media handles, or residential addresses) in your initial messages — exercise caution before sharing personal information with any other member
• Exercise independent judgment in evaluating the authenticity of other members

Weddyfyp does not monitor private message content in real time, but we reserve the right to review messages in response to complaints or to investigate potential violations of these Terms.

The Company is not responsible for any loss, harm, or dispute arising from communications between members, whether on the Platform or off it.`,
  },
  {
    id: 'interest',
    title: '10. Interest, Shortlisting, and Connections',
    content: `Weddyfyp provides features that allow members to express interest in other profiles, shortlist profiles for future review, and establish connections. When using these features:

• Expressing interest in another member's profile is a non-binding gesture and does not constitute any commitment
• The decision to accept or decline an interest rests entirely with the receiving member
• Shortlisted profiles are saved privately and are not visible to the shortlisted member
• Members are encouraged to engage respectfully when connections are established
• For effective matchmaking, it is recommended that you log in regularly, review connection requests, and respond appropriately to show your interest

The availability of interest, shortlist, and connection features may vary depending on your subscription plan. Free members may have limited access to these features.

The Company makes no guarantee that expressing interest in a profile will result in a connection, or that any connection will progress toward marriage.`,
  },
  {
    id: 'search',
    title: '11. Search and Match Features',
    content: `Weddyfyp provides search and match functionality to help members find profiles that align with their preferences. You understand and acknowledge that:

• Search results are generated based on the criteria you enter and the information provided by other members
• The accuracy of search results depends entirely on the accuracy of information entered by all members
• Match suggestions, recommendations, or compatibility scores (if available) are generated algorithmically and are provided as tools to assist your search — they are not guarantees of compatibility or suitability

The Company reserves the right to modify, update, or remove search and match features at any time without prior notice.`,
  },
  {
    id: 'premium',
title: '12. Pay-As-You-Go Services and Profile Access',

content: `Weddyfyp operates on a pay-as-you-go model and does not require users to purchase recurring subscriptions. Users may browse profiles and use standard platform features subject to the applicable service terms.

Certain features, including access to contact details or communication opportunities with specific members, may require a one-time payment. Fees are charged on a per-profile or per-service basis as displayed within the platform at the time of purchase.

By purchasing access to a profile or service:

• You confirm that you are authorised to use the payment method provided.
• You authorise Weddyfyp to charge the applicable fee for the selected profile access or service.
• You acknowledge that payments are made for the specific service or profile access purchased and do not constitute a subscription.
• You understand that purchased access is personal to your account and may not be transferred, shared, resold, or assigned to another user.

All applicable fees, charges, and payment terms will be displayed before a purchase is completed. Weddyfyp reserves the right to modify pricing, introduce new paid features, or discontinue existing services at any time.

Unless otherwise required by applicable law, payments made for profile access or other paid services are non-refundable once the purchased access or service has been provided.`,

 },
  {
    id: 'payment',
    title: '13. Payment and Billing',
    content: `All payments on Weddyfyp are processed in Indian Rupees (INR) unless otherwise specified. Prices displayed are inclusive of applicable goods and services tax (GST) unless stated otherwise.

Payments on Weddyfyp can be made through Net Banking, Debit Card, Credit Card, UPI, RTGS, NEFT, or other available digital payment methods, in accordance with prevailing RBI guidelines. Activation of paid features will occur only upon successful payment confirmation. In case of failed or dishonored payments, your access to the paid feature may be temporarily suspended until full settlement is made.

Payments are processed through secure third-party payment gateways. By completing a payment:
• You confirm that the payment method belongs to you or that you are authorised to use it
• You authorise the Company to charge the stated amount to your payment method
• You acknowledge that the Company does not store complete card details — payment processing is handled by certified third-party processors

In the event of a failed transaction, please check your bank statement before attempting to pay again. If your account has been charged but the subscription has not been activated, contact us at info@weddyfyp.com with transaction details within 7 days.

The Company is not responsible for any additional charges, fees, or currency conversion costs that your bank or payment provider may apply.`,
  },
  {
    id: 'refund',
    title: '14. Refund and Cancellation Policy',
    content: `All subscription fees and one-time purchases made on Weddyfyp are generally non-refundable once activated and access to premium features has been provided.

Exceptions to this policy:
• If the Platform experienced a significant, sustained technical failure during your subscription period that prevented you from using the core features, and you reported this to us promptly, we will evaluate a proportional refund on a case-by-case basis
• If you were charged incorrectly due to a billing error on our part, we will issue a full correction or refund
• If you are a resident of a jurisdiction whose consumer protection laws mandate a cooling-off period, your statutory rights are not affected by this policy

To submit a refund request, email info@weddyfyp.com with the subject "Refund Request", including your registered mobile number, transaction ID, and the reason for your request. All requests must be submitted within 7 days of the charge.

We will respond to refund requests within 10 working days of receipt.`,
  },
  {
    id: 'privacy',
    title: '15. Privacy',
    content: `We take your privacy very seriously and are committed to handling your personal information responsibly. Our Privacy Policy, which is incorporated into these Terms by reference, explains in full detail how we collect, use, store, protect, and share your personal information.

Key privacy commitments:
• Your contact details (phone number, email address) are not visible to other members unless you choose to share them directly
• Every member is verified using a mobile OTP to reduce fraudulent registrations
• We do not sell or rent your personal data to any third party for commercial advertising purposes
• You can manage your profile visibility settings at any time from within the Platform

By using Weddyfyp, you consent to the collection and use of your information as described in our Privacy Policy. If you have any questions or concerns about how your data is handled, please write to us at info@weddyfyp.com.`,
  },
  {
    id: 'data',
    title: '16. Data Security',
    content: `The Company implements appropriate technical and organisational measures to protect your personal data against unauthorised access, alteration, disclosure, or destruction. Our security measures include:

• Encryption of data in transit using TLS (Transport Layer Security)
• Encryption of sensitive data at rest using industry-standard protocols
• Access controls that limit internal access to member data strictly to authorised personnel with a legitimate operational need
• Regular security reviews and infrastructure audits
• Mobile number verification as a primary measure to reduce fraudulent accounts

While we take all reasonable precautions, no internet-based system can be guaranteed to be completely secure. You are responsible for:
• Keeping your account credentials confidential
• Logging out of your account when using shared or public devices
• Notifying us immediately if you suspect unauthorised access to your account

In the event of a data breach that is likely to affect your rights or interests, we will notify you as required by applicable law.`,
  },
  {
    id: 'ip',
    title: '17. Intellectual Property Rights',
    content: `All intellectual property rights in the Weddyfyp Platform — including but not limited to the software, application code, website design, graphics, user interface, brand name, logo, trademarks, databases, and all original content created by the Company — are owned by or licensed to Roald Software Solutions Private Limited.

You are granted a limited, non-exclusive, non-transferable, revocable licence to access and use the Platform for its intended matrimonial purpose in accordance with these Terms. This licence does not permit you to:

• Copy, reproduce, distribute, or republish any part of the Platform without our written consent
• Create derivative works based on the Platform's content or design
• Use the Company's trademarks, logo, or brand elements in any way without prior written permission
• Frame or embed the Platform on any other website without authorisation

Any unauthorised use of our intellectual property may result in legal action.`,
  },
  {
    id: 'usercontent',
    title: '18. Content You Upload',
    content: `When you upload photographs, write a bio, set preferences, or send messages on Weddyfyp, you retain ownership of that content. However, by submitting content to the Platform, you grant Roald Software Solutions Private Limited a non-exclusive, royalty-free, worldwide licence to use, display, store, reproduce, and process that content solely for the purpose of operating the Platform, delivering our services, and improving user experience.

You represent and warrant that:
• You own or have the right to use any content you upload
• Your content does not infringe the intellectual property rights, privacy rights, or other rights of any third party
• Your content does not contain anything that is illegal, offensive, obscene, or defamatory

We will not use your personal photographs or profile content in any advertising, marketing, or promotional material without your explicit written consent. We may, however, disclose your content to law enforcement agencies or courts when legally required to do so.

The Company reserves the right to remove any uploaded photographs or submitted content that it deems — upon review — to be false, offensive, harmful, or in violation of these Terms, without prior notice.`,
  },
  {
    id: 'thirdparty',
    title: '19. Third-Party Links and Services',
    content: `The Platform may contain links to third-party websites or services (such as payment gateways, app stores, or social login providers). These links are provided for your convenience only.

The Company:
• Does not endorse, control, or take responsibility for the content, privacy practices, or terms of any third-party websites or services
• Is not liable for any loss or damage arising from your use of or reliance on any third-party site or service
• Recommends that you review the privacy policy and terms of service of any third-party service before using it

Your interactions with third-party payment gateways are governed by their own terms. The Company is not a party to those transactions beyond providing access to the payment interface.`,
  },
  {
    id: 'warranties',
    title: '20. Disclaimer of Warranties',
    content: `The Platform and all services provided through it are offered on an "as is" and "as available" basis, without warranties of any kind, express or implied.

To the fullest extent permitted by applicable law, the Company expressly disclaims:

• Any warranty that the Platform will be uninterrupted, error-free, virus-free, or completely secure
• Any warranty regarding the accuracy, completeness, or reliability of information provided by other members
• Any implied warranties of merchantability, fitness for a particular purpose, or non-infringement
• Any guarantee that using the Platform will result in a match, a relationship, or a marriage

You use the Platform at your own risk. The Company is not responsible for any decision you make — including decisions to meet another member in person — based on information available on the Platform.`,
  },
  {
    id: 'liability',
    title: '21. Limitation of Liability',
    content: `To the maximum extent permitted by applicable law:

• The Company shall not be liable for any indirect, incidental, consequential, punitive, or special damages arising from your use of the Platform, even if we have been advised of the possibility of such damages
• The Company is not responsible for any loss arising from interactions between members, whether on or off the Platform
• We do not guarantee that any match made on the Platform will result in a successful or lasting relationship or marriage
• Our total cumulative liability to you, for any claim of any nature arising out of your use of the Platform, shall not exceed the total amount paid by you to the Company in the three calendar months immediately preceding the event giving rise to the claim

Nothing in these Terms limits or excludes liability for death or personal injury caused by the Company's gross negligence or fraud, or for any other liability that cannot be excluded or limited under applicable Indian law.`,
  },
  {
    id: 'indemnity',
    title: '22. Indemnification',
    content: `You agree to indemnify, defend, and hold harmless Roald Software Solutions Private Limited, its directors, officers, employees, agents, and licensors from and against any and all claims, liabilities, damages, losses, costs, and expenses (including reasonable legal fees) arising out of or in connection with:

• Your use of or access to the Platform
• Your violation of any provision of these Terms
• Your violation of any applicable law or regulation
• Any content you upload, post, or transmit through the Platform
• Any dispute between you and another member of the Platform
• Any claim by a third party that your content or conduct infringed their rights

The Company reserves the right, at its own expense, to assume exclusive defence and control of any matter subject to indemnification by you, in which case you agree to cooperate fully with the Company's defence.`,
  },
  {
    id: 'modification',
    title: '23. Modification of Terms',
    content: `The Company reserves the right to modify, update, or replace these Terms at any time. When we make changes:

• We will update the "Last updated" date at the top of this page
• For significant changes, we will send a notification to your registered email address and/or display a notice within the Platform

You are responsible for reviewing these Terms periodically. If you continue to use the Platform after any modification takes effect, you are deemed to have accepted the updated Terms.

If you do not agree to any modification, you must immediately stop using the Platform and may delete your account.`,
  },
  {
    id: 'service',
    title: '24. Modification and Availability of Services',
    content: `The Company reserves the right to:

• Modify, update, add, or remove features of the Platform at any time, with or without prior notice
• Temporarily suspend the Platform or specific features for maintenance, security updates, or infrastructure improvements
• Permanently discontinue the Platform or any part of it, provided that reasonable advance notice is given to active subscribers

We aim to provide a reliable and continuously improving service. Where possible, we will give advance notice of planned maintenance or significant changes. However, we are not liable for any inconvenience caused by scheduled or unscheduled downtime.

The Company is not responsible for any loss arising from reliance on the continued availability of any specific feature.`,
  },
  {
    id: 'security',
    title: '25. Account Security',
    content: `You are fully responsible for maintaining the security of your Weddyfyp account. To protect your account:

• Use a strong, unique password that you do not use for any other service
• Never share your login credentials, OTP codes, or account access with any other person — including family members helping you with your profile
• Log out of your account when using shared, public, or borrowed devices
• Do not allow automated tools or third-party services to access your account on your behalf

If you believe your account has been compromised, or if you receive an OTP that you did not request, contact us immediately at info@weddyfyp.com. The Company is not responsible for any loss or damage arising from your failure to maintain adequate account security.

We will never ask you for your password by email, phone, or any other channel.`,
  },
  {
    id: 'verification',
    title: '26. Verification and Profile Trust',
    content: `Weddyfyp uses mobile OTP verification to confirm the identity of every registering member. This step significantly reduces the risk of fake accounts and ensures a base level of authenticity.

However, the Company does not independently verify all information provided in member profiles, including educational qualifications, employment details, income, family background, or any documents. Members are responsible for:

• Exercising their own due diligence when evaluating profiles
• Independently verifying important claims before making decisions
• Not relying solely on information displayed on the Platform when making personal or family decisions
• Being cautious of users who request favours or money, use multiple phone numbers to contact you, avoid video calls or in-person meetings, or do not involve family or friends in matchmaking discussions — report any suspicious behaviour immediately

The Company may, from time to time, offer optional document verification or trust badges as additional features. These are supplementary tools and do not constitute a guarantee of the accuracy of the underlying information.`,
  },
  {
    id: 'complaints',
    title: '27. Reporting and Complaints',
    content: `Weddyfyp takes member safety and platform integrity seriously. If you encounter a profile, message, or behaviour that you believe violates these Terms, you are encouraged to report it to us immediately.

To report a concern:
• Use the in-app report or flag feature on the relevant profile or message, where available
• Email us at info@weddyfyp.com with the subject "Report: Member Misconduct" and include the relevant details

Upon receiving a report:
• We will acknowledge receipt of your complaint within 48 hours
• We will investigate the matter and take appropriate action, which may include issuing a warning, suspending, or permanently removing the reported account
• We will inform you of the outcome of your report within a reasonable timeframe, subject to privacy obligations to other members

Content Moderation: The Company retains the right to remove or block any user content or profile at any time if consent for sharing the information cannot be verified, the content appears false, unlawful, or misleading, the content is obscene, defamatory, abusive, harassing, hateful, vulgar, discriminatory, or pornographic, or the profile or behaviour threatens the safety of users, employees, or the platform's integrity.

Submitting a false or malicious report is itself a violation of these Terms and may result in action being taken against your account.`,
  },
  {
    id: 'grievance',
    title: '28. Grievance Redressal',
    content: `In accordance with the Information Technology Act, 2000, and the Information Technology (Intermediary Guidelines and Digital Media Ethics Code) Rules, 2021, the Company has designated a Grievance Officer to address member concerns.

Grievance Officer:
Name: Mr. Harish
Email: info@weddyfyp.com
Phone: +91 9490023820
Address: A/P P NO 11 & 12, 206, SRI S RESIDENCY, OLD BOWENPALLY, HYDERABAD 500011, Telangana, India

Grievances may be submitted by email with the subject line "Formal Grievance". The Grievance Officer will acknowledge your complaint within 24 hours and endeavour to resolve it within 30 days of receipt, in accordance with applicable Indian regulations.

This grievance redressal mechanism is without prejudice to any other legal rights you may have under applicable law.`,
  },
  {
    id: 'suspension',
    title: '29. Suspension and Termination',
    content: `The Company may suspend, restrict, or permanently close your account at any time, with or without prior notice, in the following circumstances:

• You have breached any provision of these Terms
• We receive credible complaints of misconduct or abusive behaviour from other members
• We determine that your profile contains false, misleading, or fraudulent information
• We are required to take such action pursuant to applicable law, a court order, or a government direction
• Your account appears to be compromised or used without your authorisation
• Your account has been inactive for an extended period (typically 24 months or more)
• You have provided false consent for sharing information, or the content appears unlawful or misleading
• You misuse the messaging system or attempt to solicit or direct users to other matrimonial services

You may also close your account voluntarily at any time by following the instructions in the Delete Account section of the Platform, or by contacting us at info@weddyfyp.com. Once your marriage is finalised, you are expected to delete your profile or notify weddyfyp to remove it from the platform.

Upon termination of your account, all consequences described in Section 30 will apply immediately.`,
  },
  {
    id: 'consequences',
    title: '30. Consequences of Account Termination',
    content: `Upon termination or deletion of your account, whether at your request or by the Company:

• Your profile will be removed from public visibility within 48 hours
• Your messages and connections will no longer be accessible through the Platform
• Any unused premium subscription credit remaining at the time of termination will be forfeited without compensation, except where required by applicable consumer protection law
• Data deletion will proceed as described in our Privacy Policy — most personal data is permanently deleted within 30 days
• Certain records, including payment transactions and abuse-related reports, may be retained for up to 7 years in accordance with Indian financial and legal regulations
• Provisions intended to survive termination — including disclaimers, indemnity, limitation of liability, governing law, and arbitration clauses — will remain in full force and effect even after your account is closed

If your account was terminated by the Company for a violation of these Terms, you may not re-register on the Platform without our prior written consent. Any attempt to circumvent a ban by registering a new account may result in further action, including legal proceedings.`,
  },
  {
    id: 'governing',
    title: '31. Governing Law',
    content: `These Terms and your use of the Weddyfyp Platform are governed by and construed in accordance with the laws of India, including but not limited to:

• The Information Technology Act, 2000, and rules made thereunder
• The Consumer Protection Act, 2019
• The Indian Contract Act, 1872
• All other applicable laws and regulations of India

Subject to the arbitration clause below, any dispute, claim, or controversy arising from these Terms or your use of the Platform that is not resolved through arbitration shall be subject to the exclusive jurisdiction of the competent courts located in Hyderabad, Telangana, India.

If you are accessing the Platform from outside India, you agree to comply with all applicable local laws in addition to Indian law.`,
  },
  {
    id: 'arbitration',
    title: '32. Arbitration of Disputes',
    content: `The parties agree that any dispute, controversy, or claim arising out of or relating to these Terms, the Platform, or any service provided by the Company — including disputes regarding the validity, interpretation, breach, or termination of these Terms — shall first be attempted to be resolved through good-faith negotiation.

If the dispute is not resolved within 30 days of written notice from either party, it shall be referred to and finally resolved by binding arbitration:

• Arbitration shall be conducted in accordance with the Arbitration and Conciliation Act, 1996
• The seat and venue of arbitration shall be Hyderabad, Telangana, India
• Arbitration proceedings shall be conducted in the English language
• The arbitral award shall be final and binding on both parties
• The costs of arbitration shall be borne as directed by the arbitrator

Nothing in this clause prevents either party from seeking urgent injunctive or other equitable relief from a competent court to prevent irreparable harm pending the outcome of arbitration.`,
  },
  {
    id: 'misc',
    title: '33. Miscellaneous Provisions',
    content: `Entire Agreement: These Terms, together with our Privacy Policy and any other policies referenced herein, constitute the entire agreement between you and the Company regarding your use of the Platform, and supersede all prior agreements and understandings.

Severability: If any provision of these Terms is found to be invalid, unlawful, or unenforceable by a court of competent jurisdiction, the remaining provisions shall continue in full force and effect.

No Waiver: The failure of the Company to enforce any right or provision of these Terms shall not constitute a waiver of that right or provision. Any waiver must be in writing to be effective.

Assignment: You may not assign your rights or obligations under these Terms to any third party without the prior written consent of the Company. The Company may assign its rights and obligations under these Terms without restriction.

Force Majeure: The Company shall not be liable for any delay or failure in performance resulting from causes beyond its reasonable control, including acts of God, natural disasters, government actions, or widespread internet disruptions.

Language: In the event of any conflict between a translated version of these Terms and the English version, the English version shall prevail.`,
  },
  {
    id: 'customercare',
    title: '35. Customer Care / Customer Service',
    content: `If you encounter any issues, have questions, or wish to share feedback regarding our services, you can reach out to us through the following channels:

Company Name: Roald Software Solutions Private Limited
Email: info@weddyfyp.com
Phone: +91-9490023820

Alternatively, you can raise a support ticket directly through the Help section available in the weddyfyp mobile application. Our customer support team will promptly review and respond to your request to ensure a smooth and satisfactory experience.`,
  },
  {
    id: 'communications',
    title: '36. Communication with weddyfyp Users',
    content: `A. By using weddyfyp, you consent to receive communications related to your account, profile matches, service updates, and other notifications via email, phone calls, SMS, WhatsApp messages, or other electronic means from Roald Software Solutions Private Limited, its affiliated platforms, or trusted partners. Promotional messages may also be sent periodically to keep you informed about relevant services and offers.

B. Our automated system may send you potential match suggestions through images, messages, links, or documents. By providing your mobile number (or alternative number), you confirm that it is not registered under Do Not Disturb (DND) or National Customer Preference Register (NCPR) for blocking commercial communications.

Even if your number is registered under DND/NCPR, you agree that communications from weddyfyp (for matchmaking and service-related purposes) shall not be treated as unsolicited or promotional calls.`,
  },
  {
    id: 'feedbackconfidentiality',
    title: '37. Confidentiality of Feedback',
    content: `Any feedback, suggestions, or ideas that you provide to weddyfyp will be considered non-confidential and non-proprietary. By submitting feedback, you acknowledge and agree that:

A. The feedback does not contain any confidential or proprietary information belonging to you or any third party.

B. weddyfyp is under no obligation to maintain confidentiality regarding the submitted feedback.

C. weddyfyp is free to use, reproduce, modify, adapt, and distribute the feedback for any purpose without restriction.

D. You will not be entitled to any compensation, payment, or reimbursement for the submitted feedback under any circumstances.`,
  },
  {
    id: 'classaction',
    title: '38. Class Action Waiver',
    content: `By using weddyfyp, you agree not to initiate or participate in any class action lawsuits, class arbitration, or collective legal proceedings against weddyfyp in connection with any disputes. Any disputes must be resolved on an individual basis as outlined in these Terms and Conditions.`,
  },
  {
    id: 'falsecomplaints',
    title: '39. False Complaints and Legal Action',
    content: `If you submit a false, misleading, or malicious complaint that results in the suspension or deletion of another user's profile, weddyfyp reserves the right to:

A. Initiate civil or criminal legal action against you.

B. Seek recovery of costs and damages incurred by the company.

C. Suspend or delete your account without refund of any fees paid for individual profile connections.`,
  },
  {
    id: 'noliabilitymatch',
    title: '40. No Liability for Match Availability',
    content: `Roald Software Solutions Private Limited (weddyfyp) shall not be held responsible for any unsuccessful or unsuitable match resulting from the unavailability of profiles on weddyfyp or other matrimonial platforms owned by the company.`,
  },
  {
    id: 'noliabilityfinancial',
    title: '41. No Liability for Financial Transactions',
    content: `weddyfyp and its representatives will not be liable for any financial transactions or monetary exchanges made between users or with third parties. Users are solely responsible for verifying and safeguarding their interests before engaging in any such transactions.`,
  },
  {
    id: 'noliabilityresponse',
    title: '42. No Liability for Non-Responses',
    content: `weddyfyp will not be held responsible if other users do not respond to, acknowledge, or reciprocate communication or matrimonial proposals initiated by you. User interactions and responses are solely at the discretion of each individual member.`,
  },
  {
    id: 'paidexpiry',
    title: '43. Paid Connection Expiry',
    content: `Once you have paid to access the contact information of a specific profile, you must use that access within the allotted time frame provided. After the access period expires, you will not be able to view or retrieve the contact information again without making a new payment for that profile. Any unused calls or messages related to that connection will also expire.`,
  },
  {
    id: 'renewal',
    title: '44. Renewal of Profile Connection',
    content: `If you wish to reconnect or continue communication with the same user after the access period expires, you may make a new payment. Upon doing so, you will regain access to the profile's contact details from the new date of purchase.`,
  },
  {
    id: 'disputesbetweenusers',
    title: '45. Disputes Between Users',
    content: `A. All communications and interactions (via email, chat, phone, WhatsApp, or any other medium) between users of weddyfyp are conducted solely at their own discretion and risk. Roald Software Solutions Private Limited (weddyfyp) does not take responsibility or liability for any discussions, exchange of information, or financial transactions that occur directly between users on or outside the platform.

B. weddyfyp is not obligated to monitor, mediate, or resolve disputes that may arise between users. Any disagreements, misunderstandings, or conflicts must be resolved privately between the involved parties without involving weddyfyp as a mediator or legal party.

C. weddyfyp is not a broker, representative, or agent for any user. The platform solely provides a matchmaking service that allows individuals to connect. We do not participate in, influence, or take responsibility for the outcome of conversations, decisions, or arrangements made between users.`,
  },
  {
    id: 'nriterms',
    title: '46. Additional Terms for Non-Resident Indian (NRI) Users',
    content: `A. Applicable Law
All services provided to Non-Resident Indian (NRI) users are governed by the laws of India.

B. Dispute Resolution and Arbitration
We encourage users to first attempt to resolve any concerns or disputes through amicable discussions with our support team. If a dispute remains unresolved for 30 (thirty) days from the date it arises, it shall be settled through individual arbitration in accordance with the provisions of the Arbitration and Conciliation Act, 1996.

i. The arbitration will be conducted by a sole arbitrator, appointed by weddyfyp.
ii. The seat and venue of arbitration will be Hyderabad, Telangana, India.
iii. The language of arbitration will be English.

C. Intellectual Property Rights
Disputes or claims related to the infringement of our intellectual property rights may, at our discretion, be addressed through alternative legal remedies instead of arbitration.

D. Pricing and Renewal
If an NRI user renews access to paid services or specific user connections, charges will be based on the prevailing rates at the time of renewal. Renewals will typically be granted for a fixed 3-month duration, regardless of previous purchase terms.

E. Enforcement of Arbitration
Any action to enforce this arbitration agreement or to seek judicial support for arbitration proceedings shall be brought exclusively before the courts of Hyderabad, Telangana, India.`,
  },
  {
    id: 'acceptance',
    title: '47. Acceptance and Roles & Responsibilities',
    content: `A. Acceptance Criteria
In the context of weddyfyp, a user's acceptance is considered in the following scenarios:

1. When you view another user's contact information and proceed to reach out via call or WhatsApp message.
2. When another user expresses interest in your profile, and you respond positively.
3. When another user sends you a message, and you accept or reply to it.
4. When you send a message to another user, and they accept or respond.
5. When another user has viewed your contact information.

B. Roles and Responsibilities of weddyfyp
1. Profile Registration Support – weddyfyp's primary role is to assist customers in registering their profiles on the website/app. Post-registration, the terms and conditions within the platform govern the relationship between users and weddyfyp.
2. Data Protection – We take reasonable measures to protect sensitive user information through authentication mechanisms, access controls, and encryption.
3. Data in Transit – While we use secure standards, we cannot guarantee complete protection of user data during transmission or prevent third-party tampering before it reaches our servers.
4. Service Delays – weddyfyp is not responsible for delays or disruptions caused by factors beyond our control, including Force Majeure events.
5. Payment Policy – We are not liable for any direct financial transactions between customers and our representatives. All payments must be made only to the official account of Roald Software Solutions Pvt. Ltd.

C. Roles and Responsibilities of Customers
1. Non-Discrimination – Customers must not discriminate against service agents or other users based on race, religion, caste, gender, age, or any other legally protected characteristic.
2. Respectful Conduct – Customers are expected to treat all service agents and staff with courtesy and respect. weddyfyp reserves the right to restrict or revoke access to services if a customer behaves in an abusive, disrespectful, unlawful, or inappropriate manner.
3. Payment Compliance – Customers must not make any direct financial transactions with representatives of Roald Software Solutions Pvt. Ltd. or weddyfyp. All payments must be processed through official channels only.`,
  },
  {
    id: 'grievancecell',
    title: '48. Grievance Cell',
    content: `If you believe that another user has violated our Terms of Service or engaged in prohibited activities — such as posting obscene, offensive, harmful, or illegal content; infringing intellectual property rights; impersonating others; or violating applicable laws — you may file a grievance with us.

You can submit your concerns in writing or via email (digitally signed) to our designated Grievance Officer. Full contact details are available in the Grievance Redressal section (§28) and the Contact Us section of this document.

The Grievance Officer is available Monday to Saturday, from 10:00 AM to 6:00 PM IST (excluding Sundays and public holidays in India), and has been appointed in accordance with Rule 3(11) of The Information Technology (Intermediaries Guidelines) Rules, 2011.

All complaints must be submitted in writing and should include sufficient details to help us investigate and take appropriate action.

The Grievance Officer handles reports of violations involving content or activities that:

A. Belong to another person without proper authorization for use.

B. Are obscene, pornographic, harmful to minors, invasive of privacy, harassing or insulting on the basis of gender, racially or ethnically objectionable, encourage money laundering or gambling, or incite violence or hostility based on religion or caste.

C. Are harmful or dangerous to children.

D. Infringe on any patent, trademark, copyright, or other proprietary rights.

E. Mislead recipients by disguising the origin of messages, or knowingly spread false or misleading information.

F. Impersonate another person or entity.

G. Threaten India's unity, integrity, defense, security, sovereignty, or public order; harm relations with foreign states; or incite the commission of offenses.

H. Contain malware, viruses, or code intended to disrupt or damage computer resources.

I. Violate any applicable law in force.

We are committed to addressing legitimate grievances promptly and in accordance with applicable laws and regulations.`,
  },
  {
    id: 'contact',
    title: '49. Contact Us',
    content: `For any questions, concerns, legal notices, or requests relating to these Terms or your use of Weddyfyp, please contact us:

Company: Roald Software Solutions Private Limited
CIN: U74999TG2018PTC128175
Email: info@weddyfyp.com
Phone: +91 9490023820
Address: A/P P NO 11 & 12, 206, SRI S RESIDENCY, OLD BOWENPALLY, HYDERABAD 500011, Telangana, India

Grievance Officer: Mr. Harish
Email: info@weddyfyp.com (subject: "Formal Grievance")

We aim to respond to all formal enquiries within 30 days, as required under Indian law.

These Terms were last updated on 28 May 2026.`,
  },
];

export default function Terms() {
  const [active, setActive] = useState('intro');

  useEffect(() => {
    const handler = () => {
      const offsets = sections.map(s => {
        const el = document.getElementById(s.id);
        return el ? { id: s.id, top: el.getBoundingClientRect().top } : null;
      }).filter(Boolean);
      const visible = offsets.filter(o => o.top < 200);
      if (visible.length) setActive(visible[visible.length - 1].id);
    };
    window.addEventListener('scroll', handler, { passive: true });
    return () => window.removeEventListener('scroll', handler);
  }, []);

  return (
    <div style={{ paddingTop: '70px' }}>
      <Helmet>
        <title>Terms & Conditions - Weddyfyp Matrimony</title>
        <meta name="description" content="Read the Terms and Conditions for using Weddyfyp — India's matrimony platform. Understand your rights, responsibilities, and our service policies." />
        <link rel="canonical" href="https://weddyfyp.com/terms" />
      </Helmet>

      {/* ── Hero ── */}
      <section style={{ background: 'linear-gradient(150deg, #fdf5f8, #fdf5f8)', padding: '64px 24px', textAlign: 'center' }}>
        <div style={{ maxWidth: '680px', margin: '0 auto' }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>📋</div>
          <h1 style={{ fontSize: 'clamp(28px, 5vw, 44px)', color: '#1c1917', marginBottom: '14px' }}>Terms &amp; Conditions</h1>
          <p style={{ fontSize: '14px', color: '#9ca3af', marginBottom: '12px' }}>Last updated: 25 June 2026</p>
          <p style={{ fontSize: '15px', color: '#6b7280', lineHeight: '1.75' }}>
            Please read these Terms carefully before using Weddyfyp. They explain your rights, your responsibilities, and ours. Continued use of the Platform means you accept them in full.
          </p>
        </div>
      </section>

      {/* ── Content ── */}
      <section style={{ padding: '60px 24px 88px', background: '#fff' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto', display: 'grid', gridTemplateColumns: '260px 1fr', gap: '48px', alignItems: 'start' }}>

          {/* Sidebar */}
          <div style={{ position: 'sticky', top: '90px' }} className="terms-sidebar">
            <div style={{ background: '#faf8f7', borderRadius: '16px', padding: '18px', border: '1px solid #f3f4f6', maxHeight: 'calc(100vh - 120px)', overflowY: 'auto' }}>
              <p style={{ fontSize: '10px', fontWeight: '800', color: '#9ca3af', letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '14px' }}>CONTENTS</p>
              {sections.map(s => (
                <button key={s.id}
                  onClick={() => { document.getElementById(s.id)?.scrollIntoView({ behavior: 'smooth', block: 'start' }); setActive(s.id); }}
                  style={{
                    display: 'block', width: '100%', textAlign: 'left',
                    padding: '7px 12px', borderRadius: '8px', border: 'none',
                    background: active === s.id ? '#fce4ec' : 'transparent',
                    color: active === s.id ? '#C2185B' : '#6b7280',
                    fontSize: '12px', fontWeight: active === s.id ? '600' : '400',
                    cursor: 'pointer', marginBottom: '2px', transition: 'all 0.15s',
                    fontFamily: "'Inter', sans-serif",
                    lineHeight: '1.4',
                  }}>
                  {s.title}
                </button>
              ))}
            </div>
          </div>

          {/* Body */}
          <div>
            <div style={{ background: '#fce4ec', border: '1px solid #f8bbd0', borderRadius: '12px', padding: '16px 20px', marginBottom: '36px', display: 'flex', gap: '12px' }}>
              <span style={{ fontSize: '18px', flexShrink: 0 }}>📌</span>
              <p style={{ fontSize: '14px', color: '#374151', lineHeight: '1.65' }}>
                <strong>By using Weddyfyp you agree to these Terms.</strong> This Platform is strictly for matrimonial purposes only and is not a dating website. Operated by Roald Software Solutions Private Limited (CIN: U74999TG2018PTC128175).
              </p>
            </div>

            {sections.map(s => (
              <div key={s.id} id={s.id} style={{ marginBottom: '52px', scrollMarginTop: '96px' }}>
                <h2 style={{ fontSize: '21px', color: '#1c1917', marginBottom: '16px', paddingBottom: '12px', borderBottom: '2px solid #fce4ec' }}>
                  {s.title}
                </h2>
                <div style={{ fontSize: '15px', color: '#4b5563', lineHeight: '1.9', whiteSpace: 'pre-line' }}>
                  {s.content}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <style>{`
        @media (max-width: 768px) {
          .terms-sidebar { display: none !important; }
          section > div[style*="grid-template-columns"] { grid-template-columns: 1fr !important; }
        }
        .terms-sidebar::-webkit-scrollbar { width: 4px; }
        .terms-sidebar::-webkit-scrollbar-track { background: transparent; }
        .terms-sidebar::-webkit-scrollbar-thumb { background: #f8bbd0; border-radius: 4px; }
      `}</style>
    </div>
  );
}